The postal code of the location.

Include this field to improve inference if you have access to a reliable postal code.

This field has a maximum length of 50 characters.
